import React from 'react';

import {hasValue} from '@famly/stat_ts-utils_has-value';
import {
    getNavigationLinkRouteConfig,
    type NavigationLinkRouteConfig,
} from 'web-app/react/navigation-v2/config/navigation-link';
import type * as Types from 'web-app/react/navigation-v2/types';
import {doPathsMatch} from 'web-app/react/navigation-v2/helpers';

type Path = string;
type PathToNavigationLinkId<T> = {[k: Path]: T | undefined};

const navigationLinkIds: Types.NavigationLinkIds[] = [
    'GET_STARTED',
    'NURSERY_INFO',
    'ROOMS',
    'MANAGE_GROUP_RULES',
    'GET_STARTED_CHILDREN',
    'CHILD_IMPORT',
    'GET_STARTED_STAFF',
    'STAFF_ROLES',
    'STAFF_PERMISSIONS',
    'INVOICING_PROFILES',
    'ATTENDANCE_SCHEDULES',
    'FUNDING_GRANTS',
    'PRICING',
    'DISCOUNT_SETTINGS',
    'GET_STARTED_PLANS',
    'GET_STARTED_FAMLY_PAY',
    'INVOICE_LAYOUT',
    'ACCOUNTING_SETTINGS',
    'GET_STARTED_FAMLY_PAY_SETTINGS',
    'PARENT_BOOKING_SETTINGS',
    'OVERVIEW',
    'HOME_CUSTOMIZATION',
    'ORGANIZATION_SETTINGS',
    'CHILDREN_AND_STAFF',
    'NEWS_FEED',
    'NEWS_FEED_SINGLE_POST',
    'CHILDREN',
    'CHILDREN_OVERVIEW',
    'KIVAN_IMPORT',
    'PARENTAL_PERMISSIONS',
    'PARENTAL_PERMISSIONS_CHECK_PERMISSIONS',
    'VACATION_PLANS',
    'STAFF',
    'DOCUMENTS',
    'PARENT_DOCUMENTS',
    'CALENDAR',
    'CALENDAR_EVENT',
    'OLD_MEAL_PLANS',
    'MEALS',
    'MEAL_PLANS_V3',
    'MEAL_PLANS_V3_CREATE',
    'MEAL_PLANS_V3_VIEW',
    'MEAL_SETTINGS',
    'MEAL_BOOKINGS',
    'BILL_PAYER',
    'BILL_PAYERS',
    'LESSON_PLANS_PARENT',
    'OVERVIEW_REPORTS',
    'ROOM_PLANNING',
    'ATTENDANCE_REPORT',
    'KINDER_CONNECT',
    'KINDER_CONNECT_EXPORT',
    'KINDER_CONNECT_LINKING',
    'ATTENDANCE_STATISTICS',
    'STAFFING',
    'STAFF_ATTENDANCE_DETAILS',
    'STAFF_RATIO_REPORT',
    'STAFFING_STAFF_ATTENDANCE',
    'STAFFING_STAFF_SCHEDULE_V2',
    'STAFFING_STAFF_LEAVE',
    'STAFFING_STAFF_LEAVE_V2',
    'STAFFING_STAFF_HOURS',
    'STAFFING_STAFF_HOURS_V2',
    'INQUIRIES_V2',
    'NEW_STARTERS_ONBOARDING',
    'FORMS',
    'CRF_NEW_FORM',
    'FORM_BUILDER',
    'FORM_SUBMISSION_RESPONSE',
    'OCCUPANCY',
    'REGISTRATION',
    'OCCUPANCY_PLANNER',
    'OCCUPANCY_INDEX',
    'CHILD_DEVELOPMENT',
    'CHILD_DEVELOPMENT_OVERVIEW',
    'CHILD_DEVELOPMENT_NEXT_STEPS',
    'CHILD_DEVELOPMENT_PROGRESS_REPORT',
    'CHILD_DEVELOPMENT_COMPARE_COHORTS',
    'CHILD_DEVELOPMENT_TALLY',
    'CHILD_DEVELOPMENT_TWO_YEAR_CHECKS',
    'CHILD_DEVELOPMENT_GROUP_OBSERVATION',
    'ACTIVITY_LIBRARY',
    'ACTIVITY_LIBRARY_SINGLE_LIBRARY',
    'ACTIVITY_LIBRARY_SINGLE_ACTIVITY',
    'LESSON_PLANS',
    'CURRICULUM_LIST',
    'CURRICULUM_BUILDER_LIST',
    'CURRICULUM_BUILDER_CREATE',
    'CURRICULUM_BUILDER_DUPLICATE',
    'CURRICULUM_BUILDER_SHOW',
    'CURRICULUM_SHOW',
    'ACCIDENTS_INCIDENTS',
    'MEDICATION_FORMS',
    'IMMUNIZATION',
    'IMMUNIZATION_ONBOARDING',
    'HEAD_COUNT',
    'REVENUE',
    'DEBT',
    'DEBT_COLLECTION',
    'INVOICING',
    'PUBLIC_FUNDING',
    'FUNDING_SETTINGS',
    'CHILD_BASED_FUNDING',
    'FAMLY_PAY',
    'BULK_IMPORT_PAYMENT',
    'BULK_IMPORT_PAYMENT_PROTOPAYMENTS_TABLE',
    'BOOKINGS',
    'FINANCE',
    'BOOKING_PATTERN_BUILDER',
    'BULK_PATTERN_FLOW',
    'PLANS',
    'PURCHASES',
    'INVOICING_REPORTS',
    'PAYMENTS',
    'INVOICES_REPORT',
    'BILL_PAYERS_REPORT',
    'DEPOSITS_REPORT',
    'DIRECT_DEBITS_REPORT',
    'SUBSCRIPTION',
    'LISTS',
    'LISTS_FILTER',
    'HEAD_COUNT_REPORT',
    'OCCUPANCY_REPORT',
    'FAMLY_REPORT',
    'ORG_BALANCE_REPORT',
    'FAMLY_INSIGHTS',
    'ORG_DASHBOARD',
    'SETTINGS',
    'ACCOUNT_SETTINGS',
    'STORE_FEATURES',
    'FEATURE_STORE',
    'STORE_PARTNERS',
    'FAMLY_STORE_EMBED_PACKAGE_PRICING_PAGE',
    'FAMLY_STORE_TEMPLATES',
    'NOTIFICATIONS',
    'INBOX',
    'CHILD_PROFILE_ACTIVITY',
    'CHILD_PROFILE_ABOUT',
    'CHILD_PROFILE_SLEEP',
    'CHILD_PROFILE_INSTITUTION_INFO',
    'CHILD_PROFILE_LEAVE',
    'CHILD_PROFILE_PHOTOS',
    'CHILD_PROFILE_PLANS',
    'CHILD_PROFILE_BILLING',
    'CHILD_PROFILE_RELATIONS',
    'CHILD_PROFILE_FAMILY',
    'CHILD_PROFILE_PLANS_AND_INVOICES',
    'CHILD_PROFILE_NOTES',
    'CHILD_PROFILE_NOTE',
    'CHILD_PROFILE_LEARNING_JOURNEY',
    'CHILD_PROFILE_LEARNING_JOURNEY_OBSERVATION',
    'CHILD_PROFILE_LEARNING_JOURNEY_DETAILS',
    'CHILD_PROFILE_ACCIDENT_INCIDENT_REPORTS',
    'CHILD_PROFILE_SAFEGUARDING',
    'CHILD_PROFILE_PRINT_PREVIEW',
    'EMPLOYEE_PROFILE_DATA',
    'EMPLOYEE_PROFILE_RELATIONS',
    'EMPLOYEE_PROFILE_LEAVE',
    'EMPLOYEE_PROFILE_ABOUT',
    'EMPLOYEE_PROFILE_CALENDAR',
    'NO_ACCESS',
    'FINANCE_ONBOARDING',
    'MOBILE_MENU',
    'MOBILE_MENU_NAVIGATION_GROUP',
    'REPORTS',
    'REPORT_CATEGORY',
    'REPORT',
    'REPORT_LIST',
    'REPORT_LIST_FILTER',
    'REPORT_FAMLY_INSIGHTS',
    'NEW_REPORT',
    'CREATE_NEW_REPORT',
    'CREATE_NEW_REPORT_FROM_DATASET',
    'CREATE_NEW_REPORT_FROM_REPORT_TEMPLATE',
    'FINANCE_REPORTS',
    'FINANCE_REPORT',
    'LEARNING_REPORTS',
    'LEARNING_REPORT',
    'ATTENDANCE_REPORTS',
    'REPORTS_ATTENDANCE_REPORT',
    'FINANCE_LANDING_PAGE',
    'ATTENDANCE_LANDING_PAGE',
    'LEARNING_LANDING_PAGE',
    'CHILDREN_LANDING_PAGE',
    'HEALTH_SCREENING_STATEMENTS',
    'RESOURCE_LIBRARY',
    'RESOURCE_LIBRARY_SINGLE_RESOURCE',
] as const;

/**
 * This will create an object with paths as keys and NavigationLinkIds as values.
 *
 * @private This is only exported for unit testing
 */
export function _createPathToLinkIdMap(
    // The last two values are added to they can be stubbed for testing
    lookupRouteConfigFromID: (linkID: Types.NavigationLinkIds) => NavigationLinkRouteConfig,
    _navigationLinkIds?: Types.NavigationLinkIds[],
): PathToNavigationLinkId<Types.NavigationLinkIds> {
    return (_navigationLinkIds ?? navigationLinkIds).reduce((reduction, navigationLinkId) => {
        // Look up the RouteConfig for the NavigationLinkId
        const routeConfig = lookupRouteConfigFromID(navigationLinkId);

        // Only look up using NavigationRouteKey in the routeConfig to filter out possible bad entries
        // Normalise the structure of RouteConfig to get a flat list of paths
        const paths = ['topLevelRoute', 'institutionRoute', 'organizationRoute', 'customEntityRoutes']
            .map(routeConfigKey => routeConfig[routeConfigKey])
            .filter(hasValue)
            .flatMap(routeConfig =>
                routeConfig instanceof Array ? routeConfig.map(route => route.path) : [routeConfig.path],
            );

        // Add paths to reduction
        for (let i = 0; i < paths.length; i++) {
            // Since we're reducing a large array with a lot of values, we have to keep performance in mind,
            // and this is just way more performant than spreading over the reduction
            reduction[paths[i]] = navigationLinkId;
        }

        return reduction;
    }, {} as PathToNavigationLinkId<Types.NavigationLinkIds>);
}

/**
 * Example of what `pathToNavigationLinkIdMap` might look like:
 *
 * {
 *     "/account/institution/:institutionId": MockAPITypes.NavigationLinkIds.INSTITUTION_OVERVIEW,
 *     "/account/settings": MockAPITypes.NavigationLinkIds.SETTINGS,
 *     ...
 * }
 */
const pathToNavigationLinkIdMap = _createPathToLinkIdMap(getNavigationLinkRouteConfig, navigationLinkIds);

/**
 * Helper method for getting the NavigationLinkId from a hash string
 * @param hash The hash to get the navigationLinkId from. It should always start with '#/'.
 * @returns NavigationLinkId (if found) or null (otherwise)
 */
const getNavigationLinkIdFromUrl = (
    hash: string,
): {navigationLinkId: Types.NavigationLinkIds | null; isNoAccess: boolean} => {
    const currentPath = hash.split('#')[1];
    const currentPathWithoutQueryParams = currentPath?.split('?')[0];

    if (!currentPathWithoutQueryParams) {
        return {navigationLinkId: null, isNoAccess: false};
    }

    const pathFound = Object.keys(pathToNavigationLinkIdMap).find(targetPath => {
        return doPathsMatch(currentPathWithoutQueryParams, targetPath);
    });

    const queryParamsSet = currentPath.split('?')[1];
    const queryParams = new URLSearchParams(queryParamsSet);

    // if a user tries to access a feature to which he has no access to
    // when clicking in the sidebar menu or in the institutional picker dropdown
    // he will be presented with a No Access Page.

    // We want to ensure that and sidebar menu, and other navigation indicators
    // in the app, reflect the feature that the user is trying to access.
    // As such we need to return the navigationLinkId that is attached to the url, as a query param
    // with the key of noAccess

    // "/account/institution/{institutionId}/noAccess?navigationLinkId={previousLocation}"
    // i.e. "/account/institution/{institutionId}/noAccess?navigationLinkId=HEAD_COUNT"
    // would direct the user to No Access, when trying to access the HEAD_COUNT feature, when he has no access

    const navigationLinkId = pathFound ? pathToNavigationLinkIdMap[pathFound] ?? null : null;

    if (navigationLinkId === 'NO_ACCESS') {
        // Grab the `navigationLinkId` from the query params.
        const navigationLinkId = queryParams.get('navigationLinkId');

        if (!navigationLinkId) {
            return {navigationLinkId: null, isNoAccess: false};
        }

        return {navigationLinkId: navigationLinkId as Types.NavigationLinkIds, isNoAccess: true};
    } else {
        // We're not on the noAccess route, let's just return the `navigationLinkId`
        return {navigationLinkId, isNoAccess: false};
    }
};

/**
 * This hook listens to the current path in the URL (e.g. `#/account/settings`),
 * and returns the `NavigationLinkId` (`MockAPITypes.NavigationLinkIds`)
 * that links to that path (e.g. `MockAPITypes.NavigationLinkIds.SETTINGS`).
 */
const useGetCurrentPageNavigationLinkId = () => {
    return useGetCurrentPageNavigationWithNoAccessLinkId().currentPageNavigationLinkId;
};

export default useGetCurrentPageNavigationLinkId;

/**
 * This hook listens to the current path in the URL (e.g. `#/account/settings`),
 * and returns the `NavigationLinkId` (`MockAPITypes.NavigationLinkIds`) and a boolean indicating if we're on the NoAccess page.
 */
export const useGetCurrentPageNavigationWithNoAccessLinkId = () => {
    const [data, setCurrentPageNavigationLinkId] = React.useState<{
        currentPageNavigationLinkId: Types.NavigationLinkIds | null;
        isNoAccess: boolean;
    }>(() => {
        const navigationData = getNavigationLinkIdFromUrl(window.location.hash);
        return {
            currentPageNavigationLinkId: navigationData.navigationLinkId,
            isNoAccess: navigationData.isNoAccess,
        };
    });

    React.useEffect(() => {
        const hashChangeEventListener = () => {
            const navigationData = getNavigationLinkIdFromUrl(window.location.hash);
            return setCurrentPageNavigationLinkId({
                currentPageNavigationLinkId: navigationData.navigationLinkId,
                isNoAccess: navigationData.isNoAccess,
            });
        };

        window.addEventListener('hashchange', hashChangeEventListener);

        return () => {
            window.removeEventListener('hashchange', hashChangeEventListener);
        };
    }, []);

    return {currentPageNavigationLinkId: data.currentPageNavigationLinkId, isNoAccess: data.isNoAccess};
};
